module.exports = __webpack_public_path__ + "static/media/email.f36cdeb3.svg";